import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

// FCM Sender ID aus Firebase Console
const VAPID_KEY = 'BDj6QjcFKg68y8yaNU4PKL6BsqCfAmNYnb3xxDen5VZUS1OHc-qSTpnWTkZO8ax4X57bbbBbu3kSQAYDmVAxv0U'; // Anleitung folgt!

export const requestNotificationPermission = async (userId) => {
  try {
    // 1. Browser Permission
    const permission = await Notification.requestPermission();
    
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    // 2. Service Worker registrieren
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log('Service Worker registered:', registration);

    // 3. FCM Token holen
    const messaging = getMessaging();
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    if (token) {
      console.log('FCM Token:', token);
      
      // 4. Token in Firestore speichern
      await setDoc(doc(db, 'users', userId), {
        fcmToken: token,
        notificationsEnabled: true,
        lastTokenUpdate: new Date().toISOString()
      }, { merge: true });

      return token;
    }

    return null;

  } catch (error) {
    console.error('Error getting notification permission:', error);
    return null;
  }
};

export const disableNotifications = async (userId) => {
  await setDoc(doc(db, 'users', userId), {
    notificationsEnabled: false
  }, { merge: true });
};

// Foreground Message Handler (wenn App offen)
export const setupForegroundNotifications = () => {
  const messaging = getMessaging();
  
  onMessage(messaging, (payload) => {
    console.log('Foreground message:', payload);
    
    // Zeige Notification auch wenn App offen
    new Notification(payload.notification.title, {
      body: payload.notification.body,
      icon: '/logo192.png'
    });
  });
};